import { Link } from 'react-router-dom';

interface BlogPost {
  title: string;
  slug: string;
  description: string;
  category: string;
  readTime: string;
}

interface RelatedBlogPostsProps {
  posts: BlogPost[];
  title?: string;
}

export default function RelatedBlogPosts({ posts, title = "İlgili Blog Yazıları & Rehberler" }: RelatedBlogPostsProps) {
  if (!posts || posts.length === 0) {
    return null;
  }

  return (
    <section className="py-20 bg-slate-900/30">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-4">{title}</h2>
            <p className="text-gray-400 text-lg">
              Bu hizmetimizle ilgili detaylı bilgiler, rehberler ve teknik makaleler
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post, index) => (
              <Link
                key={index}
                to={`/blog/${post.slug}`}
                className="group bg-slate-800/50 border border-slate-700 rounded-xl overflow-hidden hover:border-indigo-500/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="inline-block px-3 py-1 bg-indigo-600/20 border border-indigo-500/30 rounded-full text-indigo-300 text-xs font-medium">
                      {post.category}
                    </span>
                    <span className="text-gray-400 text-xs flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {post.readTime}
                    </span>
                  </div>
                  
                  <h3 className="text-lg font-bold text-white mb-3 group-hover:text-indigo-400 transition-colors line-clamp-2">
                    {post.title}
                  </h3>
                  
                  <p className="text-gray-400 text-sm line-clamp-3 mb-4">
                    {post.description}
                  </p>
                  
                  <div className="flex items-center text-indigo-400 text-sm font-medium group-hover:text-indigo-300 transition-colors">
                    <span>Devamını Oku</span>
                    <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="text-center mt-8">
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 px-6 py-3 bg-slate-800 border border-slate-700 text-white rounded-lg font-medium hover:border-indigo-500/50 hover:text-indigo-400 transition-all duration-300"
            >
              <i className="ri-article-line"></i>
              Tüm Blog Yazılarını Görüntüle
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}